// extracted by mini-css-extract-plugin
export default {"landingContainer":"LandingPage-styles__landingContainer__Yx2bF","sideNavContainer":"LandingPage-styles__sideNavContainer__QA35h"};